import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {TenantCreateRequest, TenantsClient} from '../../../generated-client/generated-api-client';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {FormGroup} from '@angular/forms';
import {TenantService} from "../../../services/tenant.service";
import {isFormModifiedDataService} from "../../../services/data-services/navigation-data-services";

@Component({
  selector: 'app-tenant-new',
  templateUrl: './tenant-new.component.html',
  styleUrls: ['./tenant-new.component.sass'],
})
export class TenantNewComponent implements OnInit {
  constructor(
    private _titleService: Title,
    private _router: Router,
    private _tenantsClient: TenantsClient,
    private _errorProcessorService: ErrorProcessorService,
    private _tenantService: TenantService,
    private _isFormModifiedDataService: isFormModifiedDataService,
  ) {
    this._titleService.setTitle('Terület létrehozása');
  }

  ngOnInit(): void {}

  onSubmit(form: FormGroup): void {
    const request: TenantCreateRequest = {
      name: form.get('name')?.value === '' ? null : form.get('name')?.value,
      systemId: form.get('systemId')?.value === '' ? null : form.get('systemId')?.value,
      examReportModifiableLater: form.get('examReportModifiableLater')?.value,
    };
    this._tenantsClient.new(request).subscribe(
      next => {
        this._tenantService.refreshTenantSelectList(this._tenantsClient);
        this._isFormModifiedDataService.isFormModified = false;
        this._router.navigate(['/tenants'])
      },
      error => this._errorProcessorService.processError(error, true)
    );
  }
}
